module.exports = __webpack_public_path__ + "static/img/index-icon-4.236989eb.png";